<ng-container *ngIf="snackBar$ | async as current">
  <!-- trackBy id: each new message re-creates the snackbar, even if the previous one was closed -->
  <div class="relative z-[999]" *ngFor="let snackBar of [current]; trackBy: trackById">
    <lib-snackbar
      [labels]="'lib.snackbar' | translate"
      [bank]="bank"
      [theme]="snackBar.theme"
      [title]="snackBar.message"
      [showIconLeft]="true"
      [showIconRight]="false"
      [position]="'bottom'"
    ></lib-snackbar>
  </div>
</ng-container>
